<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        Button,
        Heading,
        FieldsetOrganizationName,
        InputRegistrationId,
        InputTaxId,
        InputVatId,
        OrganizationForm,
        SESSION_ORGANIZATION,
        ADDRESS_STORE,
        openModal,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { Organization } from 'src/app/types';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const COUNTRYCODE = Object.values($ADDRESS_STORE).find(address => address.type === 'main')?.countryCode;

    const LEGAL: Organization['legal'] = { countryCode: COUNTRYCODE };
    let { name } = $SESSION_ORGANIZATION ?? {};

    /* INTERNALS ------------------------------------------------------------------------------- */

    const onSave = (): void => {
        openModal('#onboarding');
    };

</script>

<div class = 's8-wrap'>

    <OrganizationForm
        action = 'update'
        on:save = { onSave }
        organization = { { ...$SESSION_ORGANIZATION, legal: { ...LEGAL }, name } }
    >

        <Heading size = 'md'>Check Financing Eligibility</Heading>

        <FieldsetOrganizationName
            bind:entity = { LEGAL.entity }
            bind:name = { name }
            bind:countryCode = { LEGAL.countryCode }
        />

        <InputTaxId bind:value = { LEGAL.taxId } countryCode = { LEGAL.countryCode }/>
        <InputVatId
            bind:value = { LEGAL.vatId }
            countryCode = { LEGAL.countryCode }
        />
        <InputRegistrationId bind:value = { LEGAL.registrationId } countryCode = { LEGAL.countryCode }/>

        <div class = 's8-footer'>

            <Button
                type = 'button'
                label = 'Cancel'
                color = 'neutral'
                css = 'w-full'
                url = '#onboarding'
            />

            <Button
                type = 'submit'
                label = 'Save'
                css = 'w-full'
            />

        </div>

    </OrganizationForm>

</div>


<style lang='postcss'>

    div.s8-wrap {
        div.s8-footer {
            display: flex;
            column-gap: 10px;
            flex-grow: 1;
            align-items: flex-end;
        }
    }

</style>